export const PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN = 'PARAMETROS_SISTEMA_BUSCAR_POR_ID_BEGIN';
export const PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS = 'PARAMETROS_SISTEMA_BUSCAR_POR_ID_SUCCESS';
export const PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE = 'PARAMETROS_SISTEMA_BUSCAR_POR_ID_FAILURE';
export const PARAMETROS_SISTEMA_BUSCAR_POR_ID_DISMISS_ERROR = 'PARAMETROS_SISTEMA_BUSCAR_POR_ID_DISMISS_ERROR';
export const PARAMETROS_SISTEMA_LISTAR_BEGIN = 'PARAMETROS_SISTEMA_LISTAR_BEGIN';
export const PARAMETROS_SISTEMA_LISTAR_SUCCESS = 'PARAMETROS_SISTEMA_LISTAR_SUCCESS';
export const PARAMETROS_SISTEMA_LISTAR_FAILURE = 'PARAMETROS_SISTEMA_LISTAR_FAILURE';
export const PARAMETROS_SISTEMA_LISTAR_DISMISS_ERROR = 'PARAMETROS_SISTEMA_LISTAR_DISMISS_ERROR';
export const PARAMETROS_SISTEMA_EDITAR_BEGIN = 'PARAMETROS_SISTEMA_EDITAR_BEGIN';
export const PARAMETROS_SISTEMA_EDITAR_SUCCESS = 'PARAMETROS_SISTEMA_EDITAR_SUCCESS';
export const PARAMETROS_SISTEMA_EDITAR_FAILURE = 'PARAMETROS_SISTEMA_EDITAR_FAILURE';
export const PARAMETROS_SISTEMA_EDITAR_DISMISS_ERROR = 'PARAMETROS_SISTEMA_EDITAR_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/redux/constants.js